import { NAVIGATION_URLS } from '@libs/core';
import { TextPassage, TextLink } from '@petsmart-ui/sparky';

type AutoShipRecurring = {
    displayShipmentDate?: string;
};

export default function AutoShipRecurringShipment(props: AutoShipRecurring) {
    return (
        <>
            <TextPassage className="sparky-c-expand">
                This item has been added to your next Autoship order on{' '}
                <strong>{props?.displayShipmentDate}</strong>.
            </TextPassage>
            <TextLink
                href={NAVIGATION_URLS.velocity.account.autoShip}
                className="sparky-c-button sparky-c-button--primary add-to-cart-button"
            >
                View order
            </TextLink>
        </>
    );
}
